import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'

export default class Phone extends React.Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    field: PropTypes.object
  }

  state = {valid: false}

  validation(number) {
    const re = /^\d{9}$/
    return re.test(number)
  }

  getNumber(event) {
    if (this.validation(event)) {
      this.setState({valid: true})
    } else {
      this.setState({valid: false})
    }
    this.props.onChange(event)
  }

  renderInformation() {
    let required = '(Opcional)'
    if (!this.props.field) return null
    if (this.props.field.required) {
      required = '(Requerido)'
    }
    if (this.props.field.name) {
      return `${this.props.field.name} ${required}`
    }
    if (this.props.field.validation) {
      return `${this.props.field.validation} ${required}`
    }
    return `Texto ${required}`
  }

  messageField() {
    if (this.props.field.required) {
      if (this.state.valid) return 'Todo se ve bien (Requerido)'
      return 'Información no válida (Requerida)'
    }
    if (this.state.valid) return 'Todo se ve bien (Opcional)'
    return 'Información no válida (Opcional)'
  }

  renderClassName(textSize) {
    let myClases = '';
    if (this.props.field.required) {
      if (this.state.valid) 
        myClases = styles.requiredValid
      else 
        myClases = styles.requiredInvalid
    } else {
      if (this.state.valid) 
        myClases = styles.noRequiredValid
      else
        myClases = styles.noRequiredInvalid
    }
    if(textSize==='medium')
      myClases += ' ' + styles.medium
    else if(textSize==='large')
      myClases += ' ' + styles.large
    return myClases
  }

  render() {
    return (
      <Tooltip content={this.messageField()}>
        <input
          type="tel"
          placeholder={this.renderInformation()}
          value={this.props.value ? this.props.value.text : ''}
          onChange={event => this.getNumber(event.target.value)}
          className={this.renderClassName(this.props.field.textSize)}
          id={this.props.field.id}
          data-filled={this.props.value ? 'true' : 'false'}
          data-filler={this.props.field && this.props.field.filler}
          data-required={this.props.field && this.props.field.required ? 'true' : 'false'}
        />
      </Tooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/Page/Field/Edit/Phone/index.js